import { render, staticRenderFns } from "./KycDialog.vue?vue&type=template&id=4a4d1143"
import script from "./KycDialog.vue?vue&type=script&lang=ts"
export * from "./KycDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports